// Blood pressure categories per AHA / Harvard Health chart.
// Overall category is the higher of the systolic and diastolic categories.
export const BP_LEVELS = {
    low:      { rank: 0, label: 'Low Blood Pressure',            color: '#5B9BD5', text: '#fff' },
    normal:   { rank: 1, label: 'Normal',                        color: '#8DC63F', text: '#000' },
    elevated: { rank: 2, label: 'Elevated',                      color: '#FFEB3B', text: '#000' },
    stage1:   { rank: 3, label: 'Hypertension Stage 1',          color: '#F5A623', text: '#000' },
    stage2:   { rank: 4, label: 'Hypertension Stage 2',          color: '#E2582B', text: '#fff' },
    crisis:   { rank: 5, label: 'Hypertensive Crisis',           color: '#B71C1C', text: '#fff' },
    invalid:  { rank: -1, label: 'Invalid B.P',                  color: '#000000', text: '#fff' },
};

export const sysLevel = (sys) => {
    const v = Number(sys);
    if (!Number.isFinite(v) || v <= 0) return 'invalid';
    if (v > 180) return 'crisis';
    if (v >= 140) return 'stage2';
    if (v >= 130) return 'stage1';
    if (v >= 120) return 'elevated';
    if (v >= 90) return 'normal';
    return 'low';
};

export const diaLevel = (dia) => {
    const v = Number(dia);
    if (!Number.isFinite(v) || v <= 0) return 'invalid';
    if (v > 120) return 'crisis';
    if (v >= 90) return 'stage2';
    if (v >= 80) return 'stage1';
    if (v >= 60) return 'normal';
    return 'low';
};

export const bpLevel = (sys, dia) => {
    const s = sysLevel(sys), d = diaLevel(dia);
    if (s === 'invalid') return d;
    if (d === 'invalid') return s;
    return BP_LEVELS[s].rank >= BP_LEVELS[d].rank ? s : d;
};

export const sysCategory = (sys) => BP_LEVELS[sysLevel(sys)];
export const diaCategory = (dia) => BP_LEVELS[diaLevel(dia)];
export const bpCategory = (sys, dia) => BP_LEVELS[bpLevel(sys, dia)];

// Bootstrap Alert variant for a notification status string written by the backend.
export const bpStatusVariant = (status) => {
    switch (status) {
        case 'Crisis': return 'danger';
        case 'Stage 2': return 'danger';
        case 'Stage 1': return 'warning';
        case 'Elevated': return 'warning';
        case 'Low': return 'primary';
        case 'High': return 'danger';       // legacy notifications
        case 'very high': return 'danger';  // legacy notifications
        default: return 'success';
    }
};

export const bpStatusColor = (status) => {
    switch (status) {
        case 'Crisis': return BP_LEVELS.crisis.color;
        case 'Stage 2': return BP_LEVELS.stage2.color;
        case 'Stage 1': return BP_LEVELS.stage1.color;
        case 'Elevated': return BP_LEVELS.elevated.color;
        case 'Low': return BP_LEVELS.low.color;
        case 'Normal': return BP_LEVELS.normal.color;
        case 'High': case 'very high': return BP_LEVELS.stage2.color;
        default: return null;
    }
};
